export default {
  text: 'Open {{paymentGateway}} profile',
  text_generic: 'Open onboarding profile',
  toasts: {
    failed_to_create: 'Failed to open {{paymentGateway}} profile',
    link_copied: 'Link copied to clipboard',
    copy_failed: 'Failed to copy link',
  },
};
